import React from 'react';
import {Item, Menu} from 'react-contexify';
import {ReactComponent as AddNew} from 'assets/svgs/actions/add-member.svg';
import {ReactComponent as AddOld} from 'assets/svgs/actions/add-existing-user.svg';
import {ReactComponent as MoveUp} from 'assets/svgs/categories/contextmenu/up.svg';
import {ReactComponent as MoveDown} from 'assets/svgs/categories/contextmenu/down.svg';

export default ({
  menuId,
  setContextData,
  addNewMember,
  addOldMember,
  moveUp,
  moveDown,
  contextData,
  users,
  isStaff,
}) => (
  <Menu id={menuId} animation={null} onHidden={setContextData}>
    {isStaff && (
      <Item onClick={addOldMember}>
        <AddOld className="mr-2" />
        Add Old
      </Item>
    )}
    <Item onClick={addNewMember}>
      <AddNew className="mr-2" />
      Add New
    </Item>
    <Item disabled={contextData && contextData.index === 0} onClick={moveUp}>
      <MoveDown className="mr-2" />
      Move Up
    </Item>
    <Item
      disabled={contextData && contextData.index + 1 === users.length}
      onClick={moveDown}
    >
      <MoveUp className="mr-2" />
      Move Down
    </Item>
  </Menu>
);
